const queryKeyMap = new WeakMap();

let id = 0;

function getId(func: Function) {
  id += 1;
  return `${func.name}${id}`;
}

export function getQueryKey(func: Function) {
  if (queryKeyMap.get(func)) {
    return queryKeyMap.get(func);
  }
  queryKeyMap.set(func, getId(func));
  return queryKeyMap.get(func);
}
